import { render, staticRenderFns } from "./B2B.vue?vue&type=template&id=95008268&scoped=true"
import script from "./B2B.vue?vue&type=script&lang=js"
export * from "./B2B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95008268",
  null
  
)

export default component.exports